module.exports = __webpack_public_path__ + "images/emoji/flipper.f2ebbd98d9a276bf8353.png";